"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//styles

var CircularProgressBar = function CircularProgressBar(_ref) {
  var className = _ref.className,
    _ref$containerSize = _ref.containerSize,
    containerSize = _ref$containerSize === void 0 ? 32 : _ref$containerSize,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 12.8 : _ref$radius,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 1.28 : _ref$strokeWidth,
    style = _ref.style,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value;
  var normalizedRadius = radius - strokeWidth * 2;
  var circumference = 2 * Math.PI * normalizedRadius;
  var strokeDasharray = "".concat(circumference, " ").concat(circumference);
  var strokeDashoffset = circumference * (1 - value);
  var center = containerSize / 2;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: className,
    "data-cy-value": value,
    "data-testid": "CircularProgressBar",
    height: containerSize,
    style: style,
    width: containerSize
  }, /*#__PURE__*/_react["default"].createElement(_styles.BackgroundCircle, {
    cx: center,
    cy: center,
    r: normalizedRadius,
    strokeWidth: strokeWidth
  }), /*#__PURE__*/_react["default"].createElement(_styles.ForegroundCircle, {
    cx: center,
    cy: center,
    r: normalizedRadius,
    strokeDasharray: strokeDasharray,
    strokeWidth: strokeWidth,
    style: {
      strokeDashoffset: strokeDashoffset
    }
  }));
};
CircularProgressBar.propTypes = {
  className: _propTypes["default"].string,
  containerSize: _propTypes["default"].number,
  radius: _propTypes["default"].number,
  strokeWidth: _propTypes["default"].number,
  style: _propTypes["default"].object,
  value: _propTypes["default"].number
};
var _default = exports["default"] = CircularProgressBar;
//# sourceMappingURL=index.js.map